export default {
  name: "dr-button",
  computed: {
    inputListeners: function() {
      var vm = this;

      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit("input", event.target.value);
        }
      });
    }
  }
};
